import { createContext, useContext } from "react";

export const StaffingScheduleContext = createContext(null);

export const useStaffingScheduleContext = () =>
  useContext(StaffingScheduleContext);
